// extracted by mini-css-extract-plugin
export default {"product-wrapper":"Product_product-wrapper__0xLde","product-img":"Product_product-img__jr8PT","product-background":"Product_product-background__nOxXZ"};